'use client';

import React from 'react';
import Button from '../components/Button';

const Login = () => {
  const handleSignIn = () => {
    window.location.href = `${process.env.REACT_APP_BASE_API_URL}/mvapi-ui/auth/login`;
  };

  return (
    <div className="flex min-h-screen">

      {/* ── Left brand panel ── */}
      <div className="hidden lg:flex lg:w-5/12 bg-slate-900 flex-col justify-between p-12 relative overflow-hidden">
        {/* Decorative blobs */}
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-emerald-500 opacity-10" />
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-emerald-400 opacity-10" />
        <div className="absolute top-1/2 right-8 w-40 h-40 rounded-full bg-white opacity-5" />

        {/* Logo */}
        <div className="relative z-10">
          <img src="ubiqio-logo.png" alt="Ubiqio" className="h-8 w-auto brightness-0 invert" />
        </div>

        {/* Center copy */}
        <div className="relative z-10">
          <h1 className="text-4xl font-bold text-white leading-snug mb-4">
            Intelligent messaging,<br />
            <span className="text-emerald-400">delivered at scale.</span>
          </h1>
          <p className="text-slate-400 text-lg mb-10">
            The platform that powers seamless communication for modern teams and enterprises.
          </p>

          <div className="space-y-4">
            {[
              { icon: '⚡', text: 'Real-time routing & delivery' },
              { icon: '🔒', text: 'Enterprise-grade security' },
              { icon: '📊', text: 'Analytics & reporting' },
            ].map(({ icon, text }) => (
              <div key={text} className="flex items-center gap-3 bg-white/5 rounded-xl px-4 py-3 backdrop-blur-sm">
                <span className="text-xl">{icon}</span>
                <span className="text-slate-200 text-sm font-medium">{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <p className="relative z-10 text-slate-600 text-xs">
          © {new Date().getFullYear()} Ubiqio. All rights reserved.
        </p>
      </div>

      {/* ── Right login panel ── */}
      <div className="flex-1 flex flex-col justify-center items-center bg-gray-50 px-6 py-12 sm:px-12">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <img src="ubiqio-logo.png" alt="Ubiqio" className="h-8 w-auto mx-auto" />
        </div>

        <div className="w-full max-w-md">
          {/* Card */}
          <div className="bg-white rounded-2xl shadow-lg px-8 py-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900">Welcome back</h2>
              <p className="text-gray-500 text-sm mt-2">Sign in to your Ubiqio account</p>
            </div>

            {/* Primary sign-in */}
            <Button
              type="button"
              variant="primary"
              fullWidth
              size="lg"
              onClick={handleSignIn}
            >
              Sign in
            </Button>




{/*             Terms
            <p className="mt-6 text-center text-xs text-gray-400 leading-relaxed">
              By signing in you agree to our{' '}
              <a href="/terms" className="text-emerald-600 hover:text-emerald-500">Terms of Service</a>
              {' '}and{' '}
              <a href="/privacy" className="text-emerald-600 hover:text-emerald-500">Privacy Policy</a>.
            </p> */}
          </div>

        </div>
      </div>

    </div>
  );
};

export default Login;